import { HttpClient, HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiConstantsService } from './api-constants.service';
import { Observable } from 'rxjs';
import {
  Payment,
  PaymentCallbackParams,
  PaymentCreationParams,
  PaymentListParams,
  PaymentVerification
} from '~core/models/payment.models';
import { Pagination } from '~core/models/core.models';

/**
 * Invoice downloads, and payment listing with GreenPay gateway integration.
 */
@Injectable()
export class PaymentService {
  private _httpClient = inject(HttpClient);
  private _apiConstantsService = inject(ApiConstantsService);

  get apiUrl(): string {
    return this._apiConstantsService.paymentsUrl;
  }

  list(params?: PaymentListParams): Observable<Pagination<Payment>> {
    return this._httpClient.get<Pagination<Payment>>(this.apiUrl, {
      params: {
        sort: 'createdAt',
        desc: 'createdAt',
        ...params
      }
    });
  }

  read(id: string): Observable<Payment> {
    return this._httpClient.get<Payment>(`${this.apiUrl}/${id}`);
  }

  checkout(params: PaymentCreationParams): Observable<Payment> {
    return this._httpClient.post<Payment>(`${this.apiUrl}/checkout`, params);
  }

  verify(paymentId: string): Observable<PaymentVerification> {
    return this._httpClient.get<PaymentVerification>(
      `${this.apiUrl}/verify/${paymentId}`
    );
  }

  callback(params: PaymentCallbackParams): Observable<null> {
    return this._httpClient.post<null>(`${this.apiUrl}/callback`, params);
  }

  callbackUpdate(params: PaymentCallbackParams): Observable<null> {
    return this._httpClient.put<null>(`${this.apiUrl}/callback`, params);
  }

  downloadInvoice(id: string): Observable<HttpResponse<ArrayBuffer>> {
    return this._httpClient.get(`${this.apiUrl}/${id}/download-invoice`, {
      responseType: 'arraybuffer',
      observe: 'response'
    });
  }

  delete(id: string): Observable<null> {
    return this._httpClient.delete<null>(`${this.apiUrl}/${id}`);
  }
}
